import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { BACKEND_URL } from '../config/constants';

const PdfRN = ({ title, list, theme }) => {
  const componentRef = useRef();
  const textIcon = (theme === 'dark' ? '_dark' : '');

  const handlePrint = useReactToPrint({
    documentTitle: 'Relatório Mapa RN',
    content: () => componentRef.current,
  });

  return (
    <>
      <button className={'buttonIcon ' + theme} onClick={handlePrint}><img src={"/img/icon_printer" + textIcon + ".svg"} alt="" /></button>
      <div style={{ display: 'none' }}>
        <div ref={componentRef} style={{ width: '100%', height: window.innerHeight }}>
          <div className='inforow' style={{ marginTop: '40px', marginLeft: '80px', marginRight: '80px' }}>
            <div className="inforow right">
              <h3 style={{ fontSize: '20px' }}>{title}</h3 >
            </div>
            <div className="inforow left">
              <img src="/img/logo_powered_insightcare.png" alt="Insightcare" style={{ width: '12vw', position: 'relative', marginLeft: '32px', float: 'right' }} />
              {
                BACKEND_URL.includes('gruposanta') ? (
                  <img src="/img/logo_gruposanta.png" alt="Gruposanta" style={{ width: '12vw', position: 'relative', float: 'right', marginLeft: '25px' }} />
                ) : null
              }
            </div>
          </div>
          <div className="inforow" style={{ marginLeft: '80px', marginRight: '80px' }}>
            <div className='inforow right'>
              <div className='infoText' style={{ fontSize: '12px' }}>Mostrando {list.length} pacientes </div>
            </div>
            <div className='inforow left'>
              <div className='infoText' style={{ fontSize: '12px' }}>Impresso em {moment().format('HH:mm, [dia] D [de] MMMM [de] YYYY')}</div>
            </div>
          </div>
          <div className='tablePDF'>
            <table>
              <thead>
                <tr>
                  <th>Leito</th>
                  <th>Paciente</th>
                  <th>Mãe</th>
                  <th>Leito Mãe</th>
                  <th>Previsão</th>
                </tr>
              </thead>
              <tbody>
                {list.map((data) => {
                  let key = data.CODIGOLEITO + data.CODIGOATENDIMENTO;
                  let color = '';
                  let statusClass = "waiting";
                  let name = data.NOMEMAE.split(' ')[0] + ' ' + data.NOMEMAE.split(' ').slice(-1);

                  if (data.LEITOMAE != null && data.LEITOMAE.length > 1) {
                    statusClass = 'progress';
                  } else {
                    color = 'red';
                  }

                  return (
                    <tr key={key} className={statusClass}>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.LEITO}</td>
                      <td style={{ color: color }} align="left"><b>{data.NOMEPACIENTE} ({data.CODIGOATENDIMENTO})</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', }} align="left"><b>{name}</b></td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap', }} align="left">{data.LEITOMAE}</td>
                      <td style={{ overflow: 'hidden', whiteSpace: 'nowrap' }} align="left">{data.DATAPREVISTAALTA}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default PdfRN;